var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 27.5 33",
    style: {
      enableBackground: "new 0 0 27.5 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0-scroll{fill-rule:evenodd;clip-rule:evenodd;fill:#4db6ac}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Neurot6lge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Neurotolge_2",
    transform: "translate(-80 -759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(80 759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-16",
    className: "st0-scroll",
    cx: 13.8,
    cy: 30,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-22",
    className: "st0-scroll",
    cx: 8.4,
    cy: 19.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-23",
    className: "st0-scroll",
    cx: 3,
    cy: 19.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-20",
    className: "st0-scroll",
    cx: 8.4,
    cy: 24.6,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-17",
    className: "st0-scroll",
    cx: 13.8,
    cy: 24.6,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    className: "st0-scroll",
    cx: 19.2,
    cy: 24.6,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-24",
    className: "st0-scroll",
    cx: 19.2,
    cy: 19.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-25",
    className: "st0-scroll",
    cx: 24.6,
    cy: 19.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-18",
    className: "st0-scroll",
    cx: 13.8,
    cy: 19.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-19",
    className: "st0-scroll",
    cx: 13.8,
    cy: 13.8,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-26",
    className: "st0-scroll",
    cx: 13.8,
    cy: 8.4,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-27",
    className: "st0-scroll",
    cx: 13.8,
    cy: 3,
    r: 2.7
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDownArrow);
export default __webpack_public_path__ + "static/media/scroll-down-arrow.243bd5d532e0034f81df7a9808c0b1d5.svg";
export { ForwardRef as ReactComponent };